import axios from "axios";
import { toast } from "react-toastify";


const BASE_URL = "https://api.ipaisa.co.in/myapp/billPayments";


const getToken = () => sessionStorage.getItem("jwtToken");


export const apiRequest = async (endpoint, requestData) => {
  try {
    const token = getToken();
    if (!token) {
      toast.error("Authentication required!");
      return null;
    }

    const response = await axios.post(`${BASE_URL}/${endpoint}?service=${requestData.service}`, requestData, {
      headers: { Authorization: `Bearer ${token}` },
    });

   

    
    return response.data;
  
  } catch (error) {
    console.error("API Request Failed:", error);
    toast.error("Something went wrong, please try again.");
    return null;
  }
};

export const apigetRequest = async (endpoint,paramname, requestData) => {
    try {
      console.log("Service In Api Call ",requestData.service)
      const token = getToken();
      if (!token) {
        toast.error("Authentication required!");
        return null;
      }
  
      const response = await axios.get(`${BASE_URL}/${endpoint}?${paramname}=${requestData}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      console.log("Response In Api Service",response.data)
  
     
        return response.data;
       
    } catch (error) {
      // console.error("API Request Failed:", error);
      // toast.error("Something went wrong, please try again.");
      return null;
    }
  };

  
  


export const getBillerDetails = async (billerId) => {
    console.log("Biller Id ",billerId)
  return await apigetRequest("parameters","billerId",  billerId );
};

export const fetchOperatorDetails = async (billerId) => {
  console.log("Biller Id ",billerId)
return await apigetRequest("OperatorCheck","tel",billerId );
};



export const fetchRechargePlans = async (mobileNo,operator,circle) => {
  console.log("Biller Id ",mobileNo)
  return await apiRequest("prepaid/recharge", {
    mobileNo,
    operator,
    circle
  });
};


export const fetchBill = async (billerId, inputParameters,initChannels,paymentModes,transactionAmount) => {
  return await apiRequest("billfetch", {
    billerId,
    inputParameters,
    remarks: "8177819808",
    initChannels,
    paymentModes,
    transactionAmount
  });
};


export const fetchBillersByCategory = async (categoryKey, page, size) => {
  const jwtToken = sessionStorage.getItem("jwtToken");
  const apiUrl = `https://api.ipaisa.co.in/myapp/billPayments/getBillersBycategory?categoryKey=${categoryKey}&page=${page}&size=${size}`;

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch billers: ${response.statusText}`);
  }

  return response.json();
};

export const payBill = async (billerId, inputParameters, transactionAmount,initChannel,paymentModes,enquiryReferenceId,validateBiller,service) => {
  console.log("Service In paybilll ",service)
  return await apiRequest("billpay", {
    billerId,
    inputParameters,
    transactionAmount,
    enquiryReferenceId,
    initChannel,
    paymentModes,
    validateBiller,
    service
  });


 

 
};
